import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import { FaWindowClose } from "react-icons/fa";
import clinic from "../../assets/images/clinic.jpg";
import list from "../../assets/images/list.jpg";
import crm from "../../assets/images/crm.jpg";
import ecommerce from "../../assets/images/ecommerce.jpg";
import touroperator from "../../assets/images/touroperator.jpg";
import { Context } from "../../context";
import DemoCard2 from "../Demo/DemoCard2";
import Spacer from "../Utils/Spacer";
import InfoModal from "./InfoModal";
import classes from "./Project.module.css";
const url = "https://www.aroundweb.it/davidebalice.dev/data/projects.json";

const ProjectProd = () => {
  const [overlay, setOverlay] = useState(false);
  const [login, setLogin] = useState(true);
  const [viewInfo, setViewInfo] = useState(false);
  const [info, setInfo] = useState("");
  const [data, setData] = useState([]);
  const [backgroundColor, setBackgroundColor] = useState("#f1f1f1");
  const [selectedCard, setSelectedCard] = useState(null);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [viewDemo, setViewDemo] = useState(false);
  const [error, setError] = useState(false);
  const { debug, lang } = useContext(Context);

  const openPopupCard = (e, info, card) => {
    setSelectedCard(card);
    setOverlay(true);
  };

  const handleCloseCard = () => {
    setSelectedCard(null);
    setOverlay(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (username === "demo" && password === "admin_demo") {
      setViewDemo(true);
      setLogin(false);
    } else {
      setError(true);
    }
  };

  const closeInfo = () => {
    setInfo("");
    setViewInfo(false);
  };

  const getData = async () => {
    const response = await axios.get(url);
    const compareByOrder = (a, b) => a.order - b.order;
    const sortedData = [...response.data].sort(compareByOrder);
    setData(sortedData);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      {viewInfo && info && <InfoModal onClose={closeInfo} info={info} />}

      {login && (
        <div className={`${classes.requestAccessLoginBg}`}>
          <div className={`${classes.requestAccessLogin}`}>
            <div
              onClick={() => {
                setLogin(false);
              }}
              className={`${classes.FaWindowCloseContainer}`}
            >
              <FaWindowClose className={`${classes.FaWindowClose}`} />
            </div>
            <Spacer height={1} />
            {lang === "en" ? (
              <b>Access demo of some projects</b>
            ) : (
              <b>Accedi alle demo di alcuni progetti</b>
            )}
            <Spacer height={28} />
            <div className={`${classes.demoForm}`}>
              <label>Username</label>
              <input
                type="text"
                value={username}
                className={`form-control ${classes.inputForm}`}
                onChange={(e) => setUsername(e.target.value)}
              />
              <Spacer height={20} />
              <label>Password</label>
              <input
                type="password"
                value={password}
                className={`form-control ${classes.inputForm}`}
                onChange={(e) => setPassword(e.target.value)}
              />
              <Spacer height={20} />
              <input
                type="submit"
                value=" Login "
                onClick={handleSubmit}
                className={`${classes.buttonForm}`}
              />
            </div>
            <Spacer height={10} />
            {error && (
              <div className={`${classes.incorrectData}`}>Incorrect data</div>
            )}
            <Spacer height={1} />
          </div>
        </div>
      )}

      <div fluid className={classes.bg9}>
        <header className="text-center py-3">
          <h2
            className="text-5 fw-400 px-3 mt-5"
            style={{ lineHeight: "35px" }}
          >
            {lang === "en" && (
              <>On this page I will post examples of products in production</>
            )}
            {lang === "it" && (
              <>
                In questa pagina pubblicherò esempi di prodotti in produzione
                <br />
              </>
            )}
          </h2>
        </header>
        <Container
          fluid
          className="text-center pb-5 pt-5 col-xl-8"
          style={{ maxWidth: "1300px" }}
        >
          <div className={`${classes.requestAccessText}`}>
            {lang === "en" && (
              <>
                <b>Access demo</b>
                <br />
                <b>of some real projects</b>
                <br /> <br />
                Demos are <b>generic</b> and{" "}
                <b>not contains real customer/user data</b>,
                <br />
                and <b>not contains client know-how</b>.
                <br /> <br />
              </>
            )}
            {lang === "it" && (
              <>
                <b>Accesso demo</b>
                <br />
                <b>di alcuni progetti reali</b>
                <br /> <br />
                Le demo sono <b>generiche</b> e
                <b>non contengono dati reali di clienti/utenti</b>,
                <br />e <b>non contengono know-how del cliente</b>.
                <br /> <br />
              </>
            )}
          </div>

          <div className={`${classes.demoCard2Container}`}>
            {/*
              <DemoCard2
              id="2"
              title_en="Shop management"
              description_en="Crm for managing a point of sale, products, orders, suppliers."
              title_it="Gestione negozio"
              description_it="Crm per la gestione di un punto vendita, prodotti, ordini, fornitori."
              img={shop}
              url="asfasd"
              viewDemo={viewDemo}
              setLogin={setLogin}
              selectedCard={selectedCard}
              openPopupCard={openPopupCard}
            />
            */}
            <DemoCard2
              id="4"
              title_en="Editor + Ecommerce"
              description_en={<small>Sitishop platform. Web site Editor and Ecommerce.</small>}
              title_it="Editor + Ecommerce"
              description_it={<small>Piattaforma Sitishop. Editor visuale ed Ecommerce.</small>}
              img={ecommerce}
              lock={false}
              url="https://www.sitishop.it?p=0"
              viewInfo={false}
              setInfo={setInfo}
              setViewInfo={setViewInfo}
              viewDemo={true}
              setLogin={setLogin}
              selectedCard={selectedCard}
              openPopupCard={openPopupCard}
            />
            <DemoCard2
              id="5"
              title_en="Editor + Tour Operator website"
              description_en={<small>Sitishop platform. Web site Editor and Tour Operator website.</small>}
              title_it="Editor + Tour Operator website"
              description_it={<small>Piattaforma Sitishop. Editor visuale ed Tour Operator website.</small>}
              img={touroperator}
              url="https://www.sitiwebturismo.it"
              viewDemo={true}
              viewInfo={false}
              setInfo={setInfo}
              setViewInfo={setViewInfo}
              setLogin={setLogin}
              lock={false}
              selectedCard={selectedCard}
              openPopupCard={openPopupCard}
            />

            <DemoCard2
              id="8"
              title_en="Room Maker 3D"
              description_en={<small>Room Maker 3D is a web application that allows users to create and furnish 3D rooms directly in the browser. <b>Coming soon</b></small>}
              title_it="Room Maker 3D"
              description_it={<small>Room Maker 3D è un'applicazione web che permette agli utenti di creare e arredare stanze 3D direttamente nel browser. <b>Coming soon</b></small>}
              img="/assets/images/room-maker.jpg"
              url="https://www.room-maker.it"
              viewDemo={true}
              viewInfo={false}
              setInfo={setInfo}
              setViewInfo={setViewInfo}
              setLogin={setLogin}
              lock={false}
              selectedCard={selectedCard}
              openPopupCard={openPopupCard}
            />

            <DemoCard2
              id="6"
              title_en="Wedding online list"
              description_en="Software for management wedding online list and birth online list"
              title_it="Liste nozze online"
              description_it="Software gestione liste nozze e liste nascita online."
              img={list}
              url={!login ? "https://www.webdemo.cloud/demo_responsive/index.php?layout=320&rs=0&m=1&start=1&em=davide.balice@gmail.com" : ""}
              lock={false}
              viewInfo={true}
              setInfo={setInfo}
              setViewInfo={setViewInfo}
              viewDemo={viewDemo}
              setLogin={setLogin}
              selectedCard={selectedCard}
              openPopupCard={openPopupCard}
            />

            <DemoCard2
              id="3"
              title_en="Crm prestiti"
              description_en="Crm with Leads, Prestiti, clienti"
              title_it="Crm prestiti"
              description_it="Crm with Leads, Prestiti, clienti"
              img={crm}
              url={!login ? "https://crm-fin.davidebalice.dev/" : ""}
              viewDemo={viewDemo}
              setLogin={setLogin}
              lock={false}
              selectedCard={selectedCard}
              openPopupCard={openPopupCard}
            />
            <DemoCard2
              id="7"
              title_en="Clinic records"
              description_en="Software for management clinic records."
              title_it="Cartelle cliniche"
              description_it="Software per gestione cartelle cliniche."
              img={clinic}
              url={
                !login
                  ? "https://gestionale-cartelle-cliniche.davidebalice.dev"
                  : ""
              }
              viewDemo={viewDemo}
              setLogin={setLogin}
              selectedCard={selectedCard}
              lock={false}
              openPopupCard={openPopupCard}
            />
          </div>
        </Container>
        <script src="vendor/jquery/jquery.min.js"></script>
        <script src="vendor/bootstrap/js/bootstrap.bundle.min.js"></script>
        <script src="js/theme.js"></script>
      </div>
    </>
  );
};

export default ProjectProd;
